import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner'
import {ActivatedRoute} from '@angular/router'
import { Location } from '@angular/common';
import { CadastroEleicaoComponent } from 'src/app/pages/gestor/cadastro-eleicao/cadastro-eleicao.component'
import { CandidaturaService } from 'src/app/services/candidatura.service';


@Component({
  selector: 'app-parametrizacoes-assistente',
  templateUrl: './parametrizacoes-assistente.component.html',
  styleUrls: ['./parametrizacoes-assistente.component.css']
})
export class ParametrizacoesAssistenteComponent implements OnInit {
  eleicaoParametrizacao: any;
  temIntegracao: any;
  enviaEmails: any;
  temCandidaturas: any;
  candidaturaId: any;

  constructor(
    public spinner: NgxSpinnerService,
    public router: ActivatedRoute,
    private location: Location,
    private eleCad: CadastroEleicaoComponent,
    protected candidaturaService: CandidaturaService
  ) { }

 async ngOnInit() {
    this.spinner.show();
    this.eleicaoParametrizacao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.spinner.hide();
  }


  voltar(){
    sessionStorage.removeItem("eleicaoClicadaParametrizacao");
    this.location.back();
  }
}
